(function() {
  'use strict';
  
  const BreadcrumbsHierarchy = {
    init() {
      this.containers = document.querySelectorAll('[data-breadcrumbs-hierarchy]');
      if (this.containers.length === 0) return;
      
      this.waitForHeaderHierarchy(() => {
        this.containers.forEach(container => this.buildBreadcrumbs(container));
      });
    },
    
    waitForHeaderHierarchy(callback) {
      if (window.headerHierarchy) {
        callback();
        return;
      }
      
      let attempts = 0;
      const maxAttempts = 50;
      const interval = setInterval(() => {
        attempts++;
        if (window.headerHierarchy) {
          clearInterval(interval);
          callback();
        } else if (attempts >= maxAttempts) {
          clearInterval(interval);
        }
      }, 100);
    },
    
    buildBreadcrumbs(container) {
      const targetUrl = container.dataset.targetUrl;
      const targetTitle = container.dataset.targetTitle;
      const isProduct = container.dataset.isProduct === 'true';
      const productTitle = container.dataset.productTitle;
      const collectionUrl = container.dataset.collectionUrl;
      const collectionTitle = container.dataset.collectionTitle;
      
      if (!targetUrl || !targetTitle) return;
      
      const path = this.findPathInHeaderHierarchy(targetUrl, targetTitle);
      if (!path || path.length < 2) return;
      
      const breadcrumbsHTML = this.buildBreadcrumbsHTML(path, {
        isProduct,
        productTitle,
        collectionUrl,
        collectionTitle,
        container
      });
      
      container.innerHTML = breadcrumbsHTML;
    },
    
    findPathInHeaderHierarchy(targetUrl, targetTitle) {
      if (!window.headerHierarchy?.menuStructure?.blocks) return null;
      
      for (const block of window.headerHierarchy.menuStructure.blocks) {
        if (block.menuLinks) {
          const foundPath = this.findPathInLinks(block.menuLinks, targetUrl, targetTitle, [block]);
          if (foundPath) return foundPath;
        }
        
        if (block.settings?.menuItemLink === targetUrl) {
          return [block];
        }
      }
      
      return null;
    },
    
    findPathInLinks(links, targetUrl, targetTitle, currentPath) {
      for (const link of links) {
        const newPath = [...currentPath, link];
        
        if (link.url === targetUrl || link.title.toLowerCase() === targetTitle.toLowerCase()) {
          return newPath;
        }
        
        if (link.children?.length > 0) {
          const foundPath = this.findPathInLinks(link.children, targetUrl, targetTitle, newPath);
          if (foundPath) return foundPath;
        }
      }
      return null;
    },
    
    buildBreadcrumbsHTML(path, options) {
      const { isProduct, productTitle, collectionUrl, collectionTitle, container } = options;
      const icon = container.dataset.icon || '›';
      const linkClass = container.dataset.linkClass || 'nav-link';
      const dividerClass = container.dataset.dividerClass || 'breadcrumb__divider';
      const lastItemClass = container.dataset.lastItemClass || '';
      
      let html = '';
      
      const headerBlock = path[0];
      if (headerBlock?.settings?.heading) {
        html += this.createLink(headerBlock.settings.heading, headerBlock.settings.menuItemLink || '#', linkClass, container);
        html += this.createDivider(icon, dividerClass, container);
      }
      
      for (let i = 1; i < path.length; i++) {
        const item = path[i];
        const isLast = i === path.length - 1;
        
        if (isLast) {
          if (isProduct && productTitle) {
            html += this.createLink(item.title, item.url, linkClass, container);
            html += this.createDivider(icon, dividerClass, container);
            html += `<span class="${lastItemClass}">${productTitle}</span>`;
          } else {
            html += `<span class="${lastItemClass}">${item.title}</span>`;
          }
        } else {
          html += this.createLink(item.title, item.url, linkClass, container);
          html += this.createDivider(icon, dividerClass, container);
        }
      }
      
      return html;
    },
    
    createLink(title, url, className, container) {
      const style = container.dataset.linkStyle || '';
      return `<a class="${className}" href="${url}" title="${title}"${style ? ` style="${style}"` : ''}>${title}</a>`;
    },
    
    createDivider(icon, className, container) {
      const style = container.dataset.dividerStyle || '';
      return `<span class="${className}"${style ? ` style="${style}"` : ''} aria-hidden="true">${icon}</span>`;
    }
  };
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => BreadcrumbsHierarchy.init());
  } else {
    BreadcrumbsHierarchy.init();
  }
})();
